<template>
  <div class="modal-card move-modal">
    <header class="modal-card-head">
      <h4 class="modal-card-title">
        Material Notes
      </h4>
    </header>
    <section class="modal-card-body is-size-2 is-marginless">
      <div class="columns is-multiline">
        <div class="column is-full">
          <h3 class="is-size-3 has-text-weight-semibold mb-2">Material</h3>
          <p class="is-size-3 has-text-black-bis mb-4"> {{item.name}}</p>
          <div class="is-divider my-0"></div>
        </div>
        <div v-for="(material) in data" class="column is-full">
         <div class="columns">
            <div class="column">
              <h3 class="is-size-3 has-text-weight-semibold mb-2">Material Request</h3>
               <p class="is-size-3 has-text-black-bis mb-2"> {{material.name}}</p>
              <p class="is-size-3 is-size-3 has-text-grey-dark">{{$_.get(material.created,'by.user.name',fullName)}}</p>
            </div>
            <div class="column is-narrow is-flex is-align-items-flex-end">
               <div class="is-flex is-align-items-center">
                <div v-if="!material.isEditable" class="is-flex is-align-items-center">
                  <p class="has-text-right is-size-3 has-text-grey-dark mr-1">
                    {{$filters.fullDateTime(getModifiedDate(material))}}
                  </p>
                  <div class="is-divider-vertical mb-0 is-pulled-right"></div>
                </div>
                <button
                  class="button px-0 ml-2  has-text-black-bis"
                  v-tooltip="'Edit'"
                  v-if="!material.isEditable"
                  @click="material.isEditable = true">
                  <i class="icon-edit"
                    >
                  </i>
                </button>
                <button
                  class="mr-2 button has-text-weight-bold has-background-white is-outlined is-size-4"
                  v-tooltip="'Cancel'"
                  v-if="material.isEditable"
                  @click="cancelEdit">
                  Cancel 
                </button>
                <button
                  class="button has-text-weight-bold has-background-black-bis has-text-white is-size-4"
                  v-tooltip="'Save'"
                  v-if="material.isEditable"
                  @click="saveItemNotes(material)">
                  Save
                </button>
              </div>
            </div>
          </div>
          <div class="order-note">
            <textarea class="textarea"   :disabled="!material.isEditable" rows="5" v-model="material.note"></textarea>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot is-justify-content-flex-end">
      <button class="button has-background-black-bis"
        @click.once="cancel"
        :disabled="disableDoneBtn"
       >Close</button>
    </footer>
  </div>
   <o-loading :full-page="true" :active="isLoading" :can-cancel="false"></o-loading>
</template>
<script>
import {
  defineComponent, defineAsyncComponent, reactive, toRefs, ref,
  onBeforeMount,
  computed,
} from 'vue';
import SearchBar from '@/components/SearchBar.vue';
import { useStore } from 'vuex';
import { get, isEmpty } from 'lodash';
import moment from 'moment';
const MfTable = defineAsyncComponent(() => import('@/components/table-fields/MfTable.vue'));

export default defineComponent({
  name: 'MaterialNotes',
  components: {
    MfTable,
    SearchBar,
  },
  props: {
    materials: Object,
    item: Object,
    fromInvIds: Object
  },
  setup(props, { emit }) {    
    const store = useStore();
    const state = reactive({
      data : [],
      isLoading: false,
      fullName: store.state.userData.fullName,
      updatedCard: {},
    });
    const cancel = () => {
      emit('close');
    };
    
    const loadData = () => {
      const { materials, item } = props;
      state.data = [];
      for (const material of materials) {
        if(props.fromInvIds.includes(material._id)) continue;
        let matItem = null;
        if(!item.catId) {
          matItem = material.items.find((itm) => itm._id === item._id);
        } else
          matItem = material.items.find((itm) => itm.catId === item.catId);
        if(matItem){  
          const matItemMemo = material.memos.find((memo) => memo.sources.some((source) => source._id === matItem._id));
          state.data.push({
            id: material._id,
            name: material.name,
            note: matItemMemo?.text ? matItemMemo.text : '',
            isEditable: false,
            itemId: matItem._id,
            created: _.get(matItemMemo, 'lastModified', matItemMemo?.created || {}),
            
          });
        }
      }
    }

    onBeforeMount(() => {
      loadData();
    });

    const cancelEdit = (material) => {
      material.isEditable = false;
      loadData();
    }

    const saveItemNotes = async (material) => {
      state.isLoading = true;
      try {
        const matOrder = props.materials.find((mat) => mat._id === material.id);
        const memo = matOrder.memos.find((memo) => memo.sources.some((source) => source._id === material.itemId));
        if (memo) {
          memo.text = material.note;
        } else {
          const matItem = matOrder.items.find((itm) => itm._id === material.itemId);
          const newMemo = matItem.newFTD('memos');
          newMemo.text = material.note;
        }
        state.updatedCard = await matOrder.save();
      } catch (error) {
        throw error;
      } finally {
         material.isEditable = false;
         state.isLoading = false
         emit('refresh-table');
      }
    }

    const disableDoneBtn = computed(() => {
      return state.data.find((item) => item.isEditable);
    });

    const getModifiedDate = (material) => {
      if (!isEmpty(state.updatedCard)) {
        const memo = state.updatedCard.memos.find((memo) => memo.sources.some((source) => source._id === material.itemId))
        if (!isEmpty(memo)) return get(memo,'lastModified.at',memo?.created?.at)
      }
      return get(material,'lastModified.at',material?.created?.at)
    }

    return {
      ...toRefs(state),
      cancel,
      saveItemNotes,
      disableDoneBtn,
      cancelEdit,
      getModifiedDate
    };
  },
});
</script>

<style scoped>
.modal-card-head {
  background-color: #fff;
  border-bottom: 0;
}
.modal-card-foot {
  background-color: #fff;
  border-top: 1px solid #a6a6a6;
}
.modal-card {
  max-width: 640px !important;
  max-height: 570px !important;
}
</style>
